import React, { useState, useEffect } from "react";
import { getFileIcon } from "../../../../../../../components/fileinformation";
import { getFileFormat } from "./utils";
import { getImage } from "./../../../../../../../utilities/storageOperations/downloadURL";
import { Row } from "antd";

function FileDownloader({
  FileName,
  FileSize,
  FilePath,
  fileName,
  fileSize,
  filePath,
}) {
  const [link, setLink] = useState(null);
  // useEffect(() => {
  //   (async () => {
  //     const response = await getImage(FileName ?? fileName);
  //     setLink(response);
  //   })();
  // }, []);
  return (
    // <a href={link} download={FileName} style={{display}}>
    <div
      style={{ display: "flex" }}
      onClick={() => {
        window.open(`${process.env.REACT_APP_S3_URL}/${FilePath ?? filePath}`);
      }}
    >
      <img src={getFileIcon(getFileFormat(FileName ?? fileName))} />
      <div
        style={{ flexDirection: "column" }}
        className="offer-card-attachement-details"
      >
        <div className="offerFileName">
          <strong>{FileName ?? fileName}</strong>
        </div>
        <div />
        <div>
          {FileSize
            ? FileSize >= 1000000
              ? Math.round(FileSize / 1000000)
              : Math.round(FileSize / 1000)
            : fileSize
            ? fileSize >= 1000000
              ? Math.round(fileSize / 1000000)
              : Math.round(fileSize / 1000)
            : null}{" "}
          {FileSize >= 1000000 || fileSize >= 1000000 ? "MB" : "KB"}
        </div>
      </div>
    </div>
    // </a>
  );
}

export default FileDownloader;
